import { lenis } from "./modules/lenis.js";
import { init as basic__init } from "./modules/basic.js";
import { init as logo_slider__init } from "./modules/logo_slider.js";
import { init as hero_slider__init } from "./modules/hero_slider.js";
import { init as hero_video__init } from "./modules/hero_video.js";
import { init as header__init } from "./modules/header.js";
import { init as project_video__init } from "./modules/project_video.js";
import { init as video_autoplay__init } from "./modules/video_autoplay.js";

const init = async () => {
   // console.log('With every Reload');
    lenis.start();
    basic__init();
    logo_slider__init();
    hero_slider__init();
    hero_video__init();
    header__init();
    project_video__init();
    video_autoplay__init();

    document.querySelector('.skip-link').addEventListener('click', function(e) {
              const target = document.querySelector('#main-content');
              if (target) {
                     target.focus();
              }
       });
};

export { init };
